/*
 * @Descripttion:
 * @Author: voanit
 * @Date: 2021-09-14 09:37:13
 * @LastEditors: voanit
 * @LastEditTime: 2021-09-16 17:41:39
 */
/*
 * title
 *
 *
 */

export default {
    name: 'card-tooltip',
    props: {
        content: {
            default: ''
        },
        contentCustomr: {
            default: () => { }
        }
    },
    render(h) {
        const { content, contentCustomr, $dataCheck, $t } = this
        return <span class="card-list">
            {content.length ?
                <el-tooltip class="item" effect="dark" placement="top-start">
                    <div slot="content">
                        <div >{content}</div>
                    </div>
                    <i class="icon-a-01wenhao iconfont-el icon"></i>
                </el-tooltip>
                :
                <el-tooltip class="item" effect="dark" placement="top-start">
                    <div slot="content">
                        <div >{contentCustomr(h)}</div>
                    </div>
                    <i class="icon-a-01wenhao iconfont-el icon"></i>
                </el-tooltip>
            }
        </span>
    }
}
